<div class="w-100" fxLayout="column" fxLayoutAlign="star start">
    <div class="common-info-container">
        @for (field of fields; track field) {
            <div class="t2 c-primary-gray-600">{{ field.label | translate }}</div>
            <div class="t2 c-primary-gray-900">{{ field.value }}</div>
        }
    </div>
    @if (documents.length) {
        <div class="divider mt-40 w-100"></div>
        <af-file-group-preview class="mt-40"
                               [attachments]="documents"
                               [title]="'i18n_af_labelSuspensionForgivenessDocuments'"
                               [showDownloadAll]="true"
                               [spinnerId]="'creditDocumentsDownload_' + transaction.id"/>
    }
</div>
